export const News = [
  {
    Title: "MAKRO โบรกแนะซื้อเป้า 48 บาท รับเข้า MSCI รอบใหม่มีผลราคาปิด 31 พ.ค",
    Picture: "https://www.kaohoon.com/wp-content/uploads/2021/06/MAKRO.jpg",
    Time: "1 day ago",
    Text: "MAKRO โบรกแนะซื้อเป้า 48 บาท รับเข้า MSCI รอบใหม่มีผลราคาปิด 31 พ.ค.นี้ พ่วงเปิดเมือง-ท่องเที่ยวฟื้น หนุนการบริโภคพุ่ง คาดกำไรปีนี้แตะ 1.1 หมื่นล้าน บล.กรุงศรี ระบุในบทวิเคราะห์วันนี้(29 พ.ค.66) บริษัท สยามแม็คโคร จำกัด (มหาชน) หรือ MAKRO คาดกำไรปี 66 โตแรง 1.1 หมื่นล้านบาท โต 47% เทียบช่วงเดียวกัน",
  },

  {
    Title1:
      "ตามติด CP ดีลธุรกิจกับรัฐบาลฝรั่งเศส ไทยได้อะไรบ้างหนุ่ย พงศ์สุขมีโอกาสตามติดคุณธนินท์, คุณสุภกิต และคุณศุภชัย เจียรวนนท์ จากเครือ #CP ไปร่วมงาน Choose France ที่รัฐบาลฝรั่งเศสเชิญบริษัทชั้นนำทั่วโลกพูดคุยเพื่อตกลงลงทุนระหว่างกัน",
    Picture1:
      "https://i.ytimg.com/vi/sIQA2ixdyC8/maxresdefault.jpg",
    Time1: "1 day ago",
    Text1:
      "พร้อมบุก Tops Foods โรงงานผลิตอาหารที่ CP ลงทุนในเบลเยี่ยม ด้วยเทคโนโลยีไมโครเวฟที่ผลิตได้มากกว่า 80,000 ถาดต่อวัน!",
  },
];

export const Stock = [
  {
    NameP1: "PTT",
    PriceP1: "฿31.00",
    ChangeP1: "-0.50",
  },
  
  {
    NameP2: "KBANK",
    PriceP2: "฿132.50",
    ChangeP2: "+0.20",
  },

  {
    NameU1: "JAS",
    PriceU1: "฿1.70",
    ChangeU1: "+16.22",
  },

  {
    NameU2: "MPIC",
    PriceU2: "฿2.82",
    ChangeU2: "+13.71",
  },

  {
    NameD1: "NC",
    PriceD1: "฿6.15",
    ChangeD1: "-18.00%",
  },

  {
    NameD2: "NATION",
    PriceD2: "฿0.09",
    ChangeD2: "-10.50",
  }

];